/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_TarjetaKanban as TarjetaKanban,
  rec_OD as OD,
  rec_Ow as Ow,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente_PD_80_68(e) {
  let t = (0, ReactCompiler.c)(19),
    { t: n, onClick: r, soloLectura: i } = e,
    a = n.estado === `COMPLETADA`,
    o = i || a,
    s;
  t[0] !== n.id || t[1] !== o
    ? ((s = {
        id: n.id,
        disabled: o,
      }),
      (t[0] = n.id),
      (t[1] = o),
      (t[2] = s))
    : (s = t[2]);
  let {
      attributes: c,
      listeners: l,
      setNodeRef: u,
      transform: d,
      transition: f,
      isDragging: p,
    } = OD(s),
    m;
  t[3] === d
    ? (m = t[4])
    : ((m = Ow.Transform.toString(d)), (t[3] = d), (t[4] = m));
  let h;
  t[5] !== m || t[6] !== f
    ? ((h = {
        transform: m,
        transition: f,
      }),
      (t[5] = m),
      (t[6] = f),
      (t[7] = h))
    : (h = t[7]);
  let _ = h,
    v = `cursor-pointer touch-none ${p ? `opacity-30` : ``}`,
    y;
  t[8] !== a || t[9] !== n
    ? ((y = <TarjetaKanban t={n} cerrada={a} />),
      (t[8] = a),
      (t[9] = n),
      (t[10] = y))
    : (y = t[10]);
  let b;
  return (
    t[11] !== c ||
    t[12] !== l ||
    t[13] !== r ||
    t[14] !== u ||
    t[15] !== _ ||
    t[16] !== v ||
    t[17] !== y
      ? ((b = (
          <div
            ref={u}
            style={_}
            {...c}
            {...l}
            onClick={r}
            className={v}
            children={y}
          />
        )),
        (t[11] = c),
        (t[12] = l),
        (t[13] = r),
        (t[14] = u),
        (t[15] = _),
        (t[16] = v),
        (t[17] = y),
        (t[18] = b))
      : (b = t[18]),
    b
  );
}
